const materialOrder = [
  window.localeStrings.product.stocked_colors,
  window.localeStrings.product.custom_colors,
];

const getSortIndex = (value, array) => {
  const index = array.indexOf(value);

  if (index === -1) return Infinity;

  return index;
};

export default function sortMaterials(materialA, materialB) {
  return (
    getSortIndex(materialA, materialOrder) -
    getSortIndex(materialB, materialOrder)
  );
}
